/* =============================================================================
   Kiro PDP · "Why you'll love it" story section · lipstick film
   -----------------------------------------------------------------------------
   Hydra Matte only (product_listing = longwear-hydra-matte-lipstick).
   snippets/kiro-v3-pdp-module.liquid loads this file, kiro-story-film.css and
   marks the story section with data-kpx-film="<image url>". Other franchises
   (Airy Matte, Velvet Soufflé) never get the attribute, so they are untouched,
   and the shared kiro-v3-story-doodle.js keeps running as before.

   Image: kiro-story-hydra-matte.png (product only, transparent, 307 x 1197).
   Copy:  the franchise "reason" blocks (Liquid falls back to the Hydra copy).

   One continuous scroll timeline, from the moment the section enters the
   screen until it releases into the next section:
     entry  macro close-up of the bullet tip rises in (tilted, shallow focus)
     01     slow push, gloss light glides over the bullet
     02     camera pulls back, full product, glow blooms
     03     settles upright, a light sweep runs down it
     04     soft-focus macro push back onto the bullet
     05     pulls back out, product lifts, shadow softens
   A hairline ring draws around the product, the 01-05 nav underlines fill as
   you move through each point, and the copy cross-fades with a soft rise.
   ============================================================================= */
(function () {
  "use strict";
  if (window.__kiroStoryFilmLoaded) return;
  window.__kiroStoryFilmLoaded = true;

  /* ---------- Motion ---------- */
  var ENTRY = 0.25;     // share of the timeline spent scrolling the section in
  var SMOOTH = 0.11;    // follow speed per frame (lower = silkier)

  /* Camera keyframes over t (0 = section enters screen, 1 = section releases).
     sc scale | rot deg | ty % shift (44 = tip centred) | b far-end blur px |
     r focus depth % | g glow | gs glow scale | so/ss shadow opacity/scale */
  var KEYS = [
    { t: 0.00, sc: 3.8,  rot: -38, ty: 44,   b: 5, r: 22,  g: 0,   gs: .55, so: 0,   ss: .5  },
    { t: 0.25, sc: 3.0,  rot: -28, ty: 40,   b: 4, r: 26,  g: .15, gs: .6,  so: 0,   ss: .5  }, // 01 in
    { t: 0.36, sc: 2.3,  rot: -18, ty: 32,   b: 3, r: 34,  g: .35, gs: .7,  so: 0,   ss: .55 }, // 01
    { t: 0.50, sc: 1.0,  rot: -3,  ty: 0,    b: 0, r: 120, g: 1,   gs: 1,   so: 1,   ss: 1   }, // 02 reveal
    { t: 0.62, sc: 1.04, rot: 0,   ty: -1,   b: 0, r: 120, g: 1,   gs: 1.04,so: 1,   ss: 1   }, // 03
    { t: 0.77, sc: 1.6,  rot: 4,   ty: 27,   b: 3, r: 30,  g: .85, gs: 1.12,so: 0,   ss: .8  }, // 04 macro
    { t: 0.92, sc: 0.95, rot: -2,  ty: -2.5, b: 0, r: 120, g: 1,   gs: .96, so: .7,  ss: 1.25}, // 05 lift
    { t: 1.00, sc: 0.97, rot: -1,  ty: -2,   b: 0, r: 120, g: 1,   gs: 1,   so: .75, ss: 1.2 }
  ];
  var SHEENS = [[0.27, 0.40], [0.55, 0.69], [0.90, 1.0]];   // light passes

  /* ---------- Helpers ---------- */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function smooth(t) { return t * t * (3 - 2 * t); }
  function sample(t) {
    for (var i = 1; i < KEYS.length; i++) {
      if (t <= KEYS[i].t) {
        var A = KEYS[i - 1], B = KEYS[i], u = smooth((t - A.t) / (B.t - A.t)), o = {};
        for (var k in A) o[k] = lerp(A[k], B[k], u);
        return o;
      }
    }
    return KEYS[KEYS.length - 1];
  }

  /* ---------- One story section ---------- */
  function setup(story) {
    if (story.__kpx) return;
    var art = story.querySelector(".kp-story-art");
    var img = story.getAttribute("data-kpx-film");
    if (!art || !img) return;
    story.__kpx = true;

    var pin = story.querySelector(".kp-story-pin") || story;
    var reasons = [].slice.call(story.querySelectorAll("[data-kp-reason]"));
    var navBtns = [].slice.call(story.querySelectorAll(".kp-story-nav button"));
    var N = reasons.length || 5;

    // Stage
    var stage = document.createElement("div");
    stage.className = "kpx-stage";
    stage.setAttribute("aria-hidden", "true");
    stage.innerHTML =
      '<div class="kpx-glow"></div>' +
      '<svg class="kpx-ring" viewBox="0 0 100 100" focusable="false">' +
        '<circle class="kpx-track" cx="50" cy="50" r="49"/>' +
        '<circle class="kpx-draw" cx="50" cy="50" r="49" pathLength="100" stroke-dasharray="100 100" stroke-dashoffset="100"/>' +
        '<circle class="kpx-head" cx="99" cy="50" r="1.1"/>' +
      "</svg>" +
      '<div class="kpx-shadow"></div>' +
      '<div class="kpx-prod">' +
        '<div class="kpx-l kpx-blur"><img alt="" decoding="async" draggable="false"></div>' +
        '<div class="kpx-l kpx-sharp"><img alt="" decoding="async" draggable="false"></div>' +
        '<div class="kpx-sheen"></div>' +
      "</div>";
    [].forEach.call(stage.querySelectorAll("img"), function (el) { el.src = img; });
    art.appendChild(stage);
    story.classList.add("kpx-on");

    // Reveal the stage once the product image is ready (no pop-in)
    var firstImg = stage.querySelector("img");
    function ready() { story.classList.add("kpx-ready"); }
    if (firstImg.complete && firstImg.naturalWidth) ready();
    else { firstImg.addEventListener("load", ready); firstImg.addEventListener("error", ready); }

    var prod = stage.querySelector(".kpx-prod");
    var sheen = stage.querySelector(".kpx-sheen");
    var draw = stage.querySelector(".kpx-draw");
    var head = stage.querySelector(".kpx-head");
    var reduce = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : { matches: false };

    // Older iPhones (no container units / aspect-ratio): pixel sizes for the CSS fallbacks
    var needSize = !(window.CSS && CSS.supports && CSS.supports("width", "1cqmin") && CSS.supports("aspect-ratio", "1"));
    function size() {
      if (!needSize) return;
      var w = stage.clientWidth, h = stage.clientHeight;
      stage.style.setProperty("--kpx-min", Math.min(w, h) + "px");
      prod.style.setProperty("--kpx-ph", (h * 0.76) + "px");
    }
    size();

    function headerH() {
      return parseFloat(getComputedStyle(story).getPropertyValue("--kp-header")) || 0;
    }
    function measure() {
      var r = story.getBoundingClientRect();
      var header = headerH();
      var vh = window.innerHeight;
      var travel = Math.max(1, story.offsetHeight - pin.offsetHeight);
      var pinned = clamp((header - r.top) / travel, 0, 1);
      var t = r.top > header
        ? ENTRY * clamp((vh - r.top) / Math.max(1, vh - header), 0, 1)
        : ENTRY + (1 - ENTRY) * pinned;
      return { t: t, pinned: r.top <= header ? pinned : 0, header: header, travel: travel };
    }

    var active = -1;
    function setText(idx) {
      if (idx === active) return;
      active = idx;
      reasons.forEach(function (el, i) {
        el.classList.toggle("kpx-act", i === idx);
        el.classList.toggle("kpx-next", i > idx);
        el.setAttribute("aria-hidden", i === idx ? "false" : "true");
      });
      navBtns.forEach(function (b, i) {
        b.classList.toggle("kpx-act", i === idx);
        if (i === idx) b.setAttribute("aria-current", "step");
        else b.removeAttribute("aria-current");
      });
    }

    function render(t, pinned) {
      if (reduce.matches) t = 0.62;
      var k = sample(t), s = prod.style, g = stage.style;
      s.setProperty("--sc", k.sc.toFixed(4));
      s.setProperty("--rot", k.rot.toFixed(3) + "deg");
      s.setProperty("--ty", k.ty.toFixed(3) + "%");
      s.setProperty("--b", k.b.toFixed(2) + "px");
      s.setProperty("--r", k.r.toFixed(1) + "%");
      g.setProperty("--go", k.g.toFixed(3));
      g.setProperty("--gs", k.gs.toFixed(3));
      g.setProperty("--so", k.so.toFixed(3));
      g.setProperty("--ss", k.ss.toFixed(3));

      // Light passes
      var sho = 0, shy = 130;
      SHEENS.forEach(function (w) {
        if (t > w[0] && t < w[1]) {
          var u = (t - w[0]) / (w[1] - w[0]);
          sho = Math.sin(Math.PI * u) * 0.6;
          shy = lerp(130, -30, smooth(u));
        }
      });
      sheen.style.setProperty("--sho", reduce.matches ? 0 : sho.toFixed(3));
      sheen.style.setProperty("--shy", shy.toFixed(1) + "%");

      // Progress ring
      var rp = clamp((t - ENTRY) / (1 - ENTRY), 0, 1);
      g.setProperty("--ro", (clamp((t - .42) / .1, 0, 1) * (k.r > 100 ? 1 : .35)).toFixed(3));
      draw.setAttribute("stroke-dashoffset", (100 * (1 - rp)).toFixed(2));
      var ang = rp * Math.PI * 2;
      head.setAttribute("cx", (50 + 49 * Math.cos(ang)).toFixed(2));
      head.setAttribute("cy", (50 + 49 * Math.sin(ang)).toFixed(2));

      // Copy + nav
      var f = pinned * N, idx = clamp(Math.floor(f), 0, N - 1);
      setText(idx);
      navBtns.forEach(function (b, i) {
        b.style.setProperty("--f", i < idx ? 1 : i === idx ? clamp(f - idx, 0, 1).toFixed(3) : 0);
      });
    }

    var cur = measure(), raf = 0;
    function tick() {
      var m = measure();
      cur.t += (m.t - cur.t) * SMOOTH;
      cur.pinned += (m.pinned - cur.pinned) * SMOOTH;
      var done = Math.abs(m.t - cur.t) < 0.0004 && Math.abs(m.pinned - cur.pinned) < 0.0004;
      if (done) { cur.t = m.t; cur.pinned = m.pinned; }
      render(cur.t, cur.pinned);
      raf = done ? 0 : requestAnimationFrame(tick);
    }
    function kick() { if (!raf) raf = requestAnimationFrame(tick); }

    // Nav: glide to the middle of that point's scroll range
    navBtns.forEach(function (b, i) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var m = measure();
        var top = story.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top - m.header + ((i + 0.5) / N) * m.travel, behavior: reduce.matches ? "auto" : "smooth" });
      }, true);
    });

    window.addEventListener("scroll", kick, { passive: true });
    window.addEventListener("resize", function () { size(); kick(); });
    window.addEventListener("orientationchange", function () { size(); kick(); });
    window.addEventListener("load", function () { size(); kick(); });
    render(cur.t, cur.pinned);
    setText(clamp(Math.floor(cur.pinned * N), 0, N - 1));
  }

  /* ---------- Boot ---------- */
  function init() {
    var stories = document.querySelectorAll("[data-kp-story][data-kpx-film]");
    for (var i = 0; i < stories.length; i++) setup(stories[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);   // theme editor
})();
